import type { CSSProperties, ReactNode } from "react";
import { useEmbedTokens } from "../theme";

type Tone = "oneTime" | "recurring" | "neutral";

interface Props {
  tone: Tone;
  children: ReactNode;
}

// A small pill label — used for marketplace charge-type tags and neutral chips.
export function EmbedBadge({ tone, children }: Props) {
  const t = useEmbedTokens();
  const byTone: Record<Tone, { bg: string; color: string }> = {
    oneTime: { bg: t.colors.primaryTint, color: t.colors.link },
    recurring: { bg: t.colors.chargeRecurringTint, color: t.colors.chargeRecurring },
    neutral: { bg: t.colors.neutralSoft, color: t.colors.neutral },
  };
  const style: CSSProperties = {
    display: "inline-block",
    background: byTone[tone].bg, color: byTone[tone].color,
    borderRadius: 999, fontSize: t.fontSize.xs, fontWeight: t.fontWeight.medium,
    padding: "3px 9px", lineHeight: t.lineHeight.tight, whiteSpace: "nowrap",
  };
  return <span style={style}>{children}</span>;
}
